// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-532fdcb4]{border-collapse:collapse}table[data-v-532fdcb4],td[data-v-532fdcb4],th[data-v-532fdcb4]{border:.5px solid #000}thead[data-v-532fdcb4]{display:table-row-group}tr td[data-v-532fdcb4]{page-break-inside:avoid}.no-border[data-v-532fdcb4]{border:none!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
